import React, { useEffect, useRef } from "react";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import { Email, Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import MessengerIcon from "../../../../../assets/images/messenger.svg";
import LauncherIcon from "../../../../../assets/images/launcher.svg";
import Youtube from "../../../layouts/footer/DefaultFooter/Youtube";
import { CloseIcon } from "../../../basic/icons/close-icon";

import "./verticalMenubar.m.css";

const VerticalMenubar = ({
  isDesktop,
  toggleVerticalMenubar,
  hamburgerMenu,
  domainSlug = "",
  socialLinks,
  publisherAttributes,
  customSocialLinks,
}) => {
  const socialShareLinks = customSocialLinks[domainSlug] || socialLinks;
  const ref = useRef(null);
  const homeMenuItem = [
    {
      title: publisherAttributes.lang === "en" ? "Home" : "প্রচ্ছদ",
      completeUrl: "/",
    },
  ];

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      toggleVerticalMenubar();
    }
  };

  useEffect(() => {
    ref.current.classList.remove("preload");

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      toggleVerticalMenubar();
    };
  });

  return (
    <div styleName="vertical-menubar-wrapper" className="vertical-menubar-wrapper">
      <div styleName={`close`} className="button-close">
        <CloseIcon color="#ffffff" width={30} height={30} />
      </div>
      <div ref={ref} className="vertical-menubar preload" styleName="vertical-menubar slide-in">
        {!isDesktop && <NavbarSearch publisherAttributes={publisherAttributes} />}
        <Navbar
          menu={homeMenuItem}
          toggleVerticalMenubar={toggleVerticalMenubar}
          lang={publisherAttributes.lang}
          dataTagCategory="Hamburger Menu"
        />
        <Navbar
          menu={hamburgerMenu}
          toggleVerticalMenubar={toggleVerticalMenubar}
          lang={publisherAttributes.lang}
          dataTagCategory="Hamburger Menu"
        />
        <div styleName="bottom-container">&nbsp;</div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  isDesktop: bool,
  toggleVerticalMenubar: func,
  hamburgerMenu: array,
  domainSlug: string,
  publisherAttributes: object,
  socialLinks: object,
  customSocialLinks: object,
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

export default connect(mapStateToProps, null)(VerticalMenubar);
